export enum BackgroundType {
  Image = 'image',
  GradientSolid = 'gradientSolid',
  GradientLinear = 'gradientLinear',
  GradientRadial = 'gradientRadial',
  GradientConic = 'gradientConic',
}
